import { create } from 'zustand';
import { PERSONAL_PAGES } from '../constants/constants';

interface SecondarySidebarState {
    isExpanded: boolean;
    toggleExpanded: () => void;
    setExpanded: (expanded: boolean) => void;
    updateBasedOnUrl: (pathname: string) => void;
}

// URL 기반으로 isExpanded 값을 결정하는 함수
const shouldBeExpanded = (pathname: string): boolean => {
    return !PERSONAL_PAGES.includes(pathname);
};

// 초기값 설정
const getInitialExpandedState = (): boolean => {
    return shouldBeExpanded(window.location.pathname);
};

export const useSecondarySidebarStore = create<SecondarySidebarState>(set => ({
    isExpanded: getInitialExpandedState(),
    toggleExpanded: () => set(state => ({ isExpanded: !state.isExpanded })),
    setExpanded: (expanded: boolean) => set({ isExpanded: expanded }),
    updateBasedOnUrl: (pathname: string) => {
        set({ isExpanded: shouldBeExpanded(pathname) });
    },
}));
